// import React from 'react';
// import {graphql} from 'react-apollo';
// import {flowRight as compose} from 'lodash';

// import queries from '../../../../../src/utils/queries'

const cliNuevo = async (tarifa, servicios, recurso, elementoArchivo, argsSelDpto, editSeqfindOneAndUpdate,
    createCliente, editClienteUpdDoc, createOdeS, editOdeSUpdDoc, editCliente,
    fechaHoraHoy, checkCrearOS, tipoOSIns) => {

  const nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  //ACTUALIZAR BD
  const crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
        const {data} = await operacionCRUD({
        variables: args
      });
      //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }

  const updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  let args = elementoArchivo
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaOS = fechaHoraHoy.substr(11, 5)

  let hacerRX = false
  let contrato = elementoArchivo.contrato
  let numeroAjuste = 0

  if(args.infAdic1){
    args.infAdic1 = args.infAdic1.trim()
  }
  args.nombreCliente = args.nombreCliente.trim()
  args.apellidoCliente = args.apellidoCliente.trim()
  args.fechaCreacionSistema = fechaHoy
  args.fechaCreate = fechaHoraHoy

  // console.log(args, fechaHoy, horaOS, checkCrearOS)
  // console.log(recurso)
  let argsAddCrear = args
  // if(contratoSequence==="SI"){
  //   argsAddCrear['contrato'] = contratoCl
  // }
  if(!args.fechaCumple){
    argsAddCrear['fechaCumple'] = null
  }
  let response = await createCliente({
    variables: argsAddCrear
  });
  const {errors, success, ok, _id} = response.data.createCliente;
  if (!success){
    this.setState({errorAdd: errors})
  }else{
    if(checkCrearOS){
      //CREAR LA OS
      let argsAdd = argsSelDpto
      argsAdd['_idTipoOS'] = tipoOSIns._idTipoOS
      argsAdd['codigoTipoOS'] = tipoOSIns.codigoTipoOS
      argsAdd['descrTipoOS'] = tipoOSIns.descrTipoOS
      argsAdd['observacAB'] = args.observacAB
      argsAdd['numeroOS'] = await nextVal('odess')
      // argsAdd['codigoTipoDocV'] = argsAdd.codigoTipoDocV
      // argsAdd['numeroDocumV'] = argsAdd.numeroDocumV
      // argsAdd['descrRecursoV'] = argsDocum.descrRecursoV!=="Seleccionar..."?argsDocum.descrRecursoV:null
      argsAdd['contrato'] = args.contrato
      argsAdd['fechaEjec'] = fechaHoy
      argsAdd['fechaFra'] = fechaHoy
      argsAdd['fechaCreate'] = fechaHoy
      argsAdd['horaSolic'] = horaOS
      // if(!args.descrCategOST||args.descrCategOST==="Seleccionar..."){
      //   argsAdd['descrCategOST'] = ""
      // }else{
      //   argsAdd['descrCategOST'] = args.descrCategOST
      // }
      // console.log(argsAdd)
      response = await createOdeS({
        variables: argsAdd
      });

      // Actualizar envFraCorreo
      let argsUpdEFC = {}
      argsUpdEFC = {
        "tipoAct": "EditarCliEnvFraCorreo",
        "contrato": args.contrato,
        "envFraCorreo": "S",
      }
      await editCliente({
        variables: argsUpdEFC
      });

      // Actualizar fechas clientes
      let actFechas = []
      let argsUpdClFe = {}
      argsUpdClFe.tipoAct = "EditarFechCli"
      argsUpdClFe._id = _id
      argsUpdClFe.fechaUltOSAb = fechaHoy
      actFechas.push(argsUpdClFe)
      // console.log(argsUpdClFe)

      let argsUpd = {}
      //Asignar recursos a la OS
      let updRec = []
      // console.log(recurso, argsSelDpto)
      if(argsSelDpto.codigoTipoDocT){
        if(recurso.length===1){
          let elemento = recurso[0]
          argsUpd = {
            "tipoAct": "EditarRecursos",
            "numeroOS": argsAdd.numeroOS,
            "_idRecurso" : elemento._id,
            "codigoTipoDoc" : elemento.codigoTipoDoc,
            "numeroDocum" : elemento.numeroDocum,
            "descrRecurso" : elemento.descrRecurso,
            "_idTipoRec" : elemento.tiporec._id,
            "descrTipoRec" : elemento.tiporec.descrTipoRec,
            "areaAprovech" : elemento.tiporec.areaAprovech
          };
          updRec.push(argsUpd)
          // console.log(argsUpd)
        }
      }
      let updDir = []
      if(argsAdd.codigoBarrio){
        //Agregar direccion a la OS
        argsUpd = {}
        argsUpd = {
          "tipoAct": "EditarDirmayor",
          "numeroOS": argsAdd.numeroOS,
          "codigoDpto": argsAdd.codigoDpto,
          "descrDpto": argsAdd.descrDpto,
          "codigoDptoDANE": argsAdd.codigoDptoDANE,
          "codigoCiudad": argsAdd.codigoCiudad,
          "nombreCiudad": argsAdd.nombreCiudad,
          "codigoMunicipioDANE": argsAdd.codigoMunicipioDANE,
          "codigoPostalDANE": argsAdd.codigoPostalDANE,
          "codigoCiudadInterno": argsAdd.codigoCiudadInterno,
          "codBarrasRdo": argsAdd.codBarrasRdo,
          "codigoZona": argsAdd.codigoZona,
          "nombreZona": argsAdd.nombreZona,
          "codigoBarrio": argsAdd.codigoBarrio,
          "nombreBarrio": argsAdd.nombreBarrio,
          "codigoTipoDocT": argsAdd.codigoTipoDocT,
          "numeroDocumT": argsAdd.numeroDocumT,
          "descrRecursoT": argsAdd.descrRecursoT,
          "codigoTipoDocR": argsAdd.codigoTipoDocR,
          "numeroDocumR": argsAdd.numeroDocumR,
          "descrRecursoR": argsAdd.descrRecursoR,

          "descrTipoVia1": args.descrTipoVia1,
          "numeroTipoVia1": args.numeroTipoVia1,
          "descrTipoVia2": args.descrTipoVia2,
          "numeroTipoVia2": args.numeroTipoVia2,
          "numeroTipoVia2F": args.numeroTipoVia2F,
          "descrTipoUnd1": args.descrTipoUnd1,
          "numeroTipoUnd1": args.numeroTipoUnd1,
          "descrTipoUnd2": args.descrTipoUnd2,
          "numeroTipoUnd2": args.numeroTipoUnd2,
        };
        if(!args.descrTipoUnd1){delete argsUpd.descrTipoUnd1}
        if(!args.numeroTipoUnd1){delete argsUpd.numeroTipoUnd1}
        if(!args.descrTipoUnd2){delete argsUpd.descrTipoUnd2}
        if(!args.numeroTipoUnd2){delete argsUpd.numeroTipoUnd2}
        updDir.push(argsUpd)
        // console.log(argsUpd)
      }

      //Agregar tarifa a la OS
      let servTarCli = []
      let servTarCliI = []

      servicios.forEach((elemento, i) => {
        // let valorServicios = 0
        // let valorAntesImptos = 0
        // let imptosCF = []
        // valorServicios = Number(elemento.rango1Valor)
        // let valorI = 0
        // elemento.imptos.forEach((elemento1, _id) => {
        //   valorI += Math.round(valorServicios * (elemento1.porcImpto / 100))
        //   imptosCF.push({codigoServicio: elemento.codigoServicio, _id: elemento1._id, codigoImpto: elemento1.codigoImpto,
        //     descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
        //     valorImpto: Math.round(valorServicios * (elemento1.porcImpto / 100))})        
        // })
        // valorServicios = (Math.round((valorServicios + valorI) / 10) * 10) - valorI
        // valorAntesImptos = valorServicios
        // valorServicios += valorI
        argsUpd = {}
        argsUpd = {
          "tipoAct": i===0?"EditarTarifa":"EditarServTar",
          "numeroOS": argsAdd.numeroOS,
          "codigoTarifa": tarifa.codigoTarifa,
          "descrTarifa": tarifa.descrTarifa,
          "cicloFact": tarifa.cicloFact?tarifa.cicloFact:null,
          "fechaVence": tarifa.fechaVence,
          "codigoServicioT": elemento.codigoServicio,
          "nombreResumidoT": elemento.nombreResumido,
          "descripcionServicioT": elemento.descripcionServicio,
          "_idSubclaseServT": elemento._idSubclaseServ,
          "codigoSubclaseServT": elemento.codigoSubclaseServ,
          "descrSubclaseServT": elemento.descrSubclaseServ,
          "_idClaseServT": elemento._idClaseServ,
          "codigoClaseServT": elemento.codigoClaseServ,
          "descrClaseServT": elemento.descrClaseServ,
          "velEfecDownstream": elemento.velEfecDownstream,
          "velEfecUpstream": elemento.velEfecUpstream,
          "codigoTipoTec": elemento.codigoTipoTec,
          "descrTipoTec": elemento.descrTipoTec,
          "colorServicio": elemento.colorServicio,
          "estadoServicio": "A",
          "rango1NumServValorIni": elemento.rango1NumServValorIni,
          "rango1NumServValorFin": elemento.rango1NumServValorFin,
          "rango1Valor": elemento.rango1Valor,
          "rango2NumServValorIni": elemento.rango2NumServValorIni,
          "rango2NumServValorFin": elemento.rango2NumServValorFin,
          "rango2Valor": elemento.rango2Valor,
          "rango3NumServValorIni": elemento.rango3NumServValorIni,
          "rango3NumServValorFin": elemento.rango3NumServValorFin,
          "rango3Valor": elemento.rango3Valor,
          "numeroServicios": 1,
          "valorServicios": elemento.valorServicios,
          "valorAntesImptos": elemento.valorAntesImptos
        };
        servTarCli.push(argsUpd)
        // console.log(argsUpd)
        elemento.imptos.forEach((elemento1, ii) => {
          if(elemento1.codigoImpto!==null){
            argsUpd = {}
            argsUpd = {
              "tipoAct": ii===0?"CrearImpto1":"CrearImpto2",
              "numeroOS": argsAdd.numeroOS,
              "codigoTarifa": tarifa.codigoTarifa,
              "codigoServicioT": elemento.codigoServicio,
              "codigoImpto": elemento1.codigoImpto,
              "descrImpto": elemento1.descrImpto,
              "porcImpto": elemento1.porcImpto,
              "valorImpto": elemento1.valorImpto,
            }
            servTarCliI.push(argsUpd)
          }
        })
      // }
      })
      // console.log(servTarCli)
      // console.log(servTarCliI)
      //Actualizar bd
      let numDocCRUD = 0
      let totDocCRUD = 3 + servTarCli.length + servTarCliI.length
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(editOdeSUpdDoc)
      }

      argsCrud[numDocCRUD] = actFechas[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = editCliente

      numDocCRUD += 1
      argsCrud[numDocCRUD] = updRec[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
      argsCrud[numDocCRUD] = updDir[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

      numDocCRUD += 1
      servTarCli.forEach((elemento, i) => {
        argsCrud[numDocCRUD] = elemento
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      
        numDocCRUD += 1
        let imptosTC = servTarCliI.filter(imptos => imptos.codigoTarifa===elemento.codigoTarifa 
                                      && imptos.codigoServicioT===elemento.codigoServicioT)
        imptosTC.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      
          numDocCRUD += 1
        })
      })
      // console.log(argsCrud, totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
      //FIN crear OS
    }
    //Agregar ciudad
    // if(this.state.addCliente&&(!args.descrTipoOS||args.descrTipoOS==="Seleccionar...")){
    if(argsSelDpto.codigoBarrio){
      let updDir = []
      let argsUpd = {}
      argsUpd = {
        "tipoAct": "EditarDirmayor",
        "_id": _id,
        "codigoDpto": argsSelDpto.codigoDpto,
        "descrDpto": argsSelDpto.descrDpto,
        "codigoDptoDANE": argsSelDpto.codigoDptoDANE,
        "codigoCiudad": argsSelDpto.codigoCiudad,
        "nombreCiudad": argsSelDpto.nombreCiudad,
        "codigoMunicipioDANE": argsSelDpto.codigoMunicipioDANE,
        "codigoPostalDANE": argsSelDpto.codigoPostalDANE,
        "codigoCiudadInterno": argsSelDpto.codigoCiudadInterno,
        "codBarrasRdo": argsSelDpto.codBarrasRdo,
      };
      updDir.push(argsUpd)
      // console.log(argsUpd)

      //Actualizar bd
      let numDocCRUD = 0
      let totDocCRUD = 1
      let argsCrud = []
      let crudColecc = []
      for(let iii=0; iii<totDocCRUD; iii++){
        argsCrud.push({ctrlCampo: 'NO_CRUD'})
      }
      for(let iii=0; iii<totDocCRUD; iii++){
        crudColecc.push(editClienteUpdDoc)
      }

      argsCrud[numDocCRUD] = updDir[0]
      argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
      argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
      crudColecc[numDocCRUD] = editClienteUpdDoc

      // console.log(argsCrud, totDocCRUD)
      await updColecc(crudColecc, argsCrud, totDocCRUD)
    }
    //FIN Agregar ciudad
  }

  const contratoAj = {contrato, hacerRX, numeroAjuste}
  // console.log(contrato)
  return contratoAj
}

export default cliNuevo

// export default compose(
//   // graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "12", orden: '_id'}}}}),

//   // graphql(queries.mutation.editOdeS, {name:'editOdeS'}),

// )(cliNuevo)
